/*
{
  root: true,
  mobile: isMobile,
  inert: !isMobile && isInert
}
*/
export default (function (styles, decisionMatrix) {
  return Object.keys(decisionMatrix).map(function (className) {
    return decisionMatrix[className] ? styles[className] : '';
  }).join(' ').trim();
});